import { h, render, Component } from 'preact';
import './time-expiration.scss';

export default class TimeExpiration extends Component {
    constructor (props) {
        super(props);
        this.messages = {
            days: [ fmtools.translate('Day1'),
                    fmtools.translate('Days234'),
                    fmtools.translate('Days5')
            ],
            timeExpiration: fmtools.translate('RadarTimeLiveLink'),
            timeExpired: fmtools.translate('RadarInvalidLink')
        }
        this.timeOut = null;
        this.state = {
            timeExpiration: 0
        }
    }

    componentDidMount() {
        let fromDate = new Date(this.props.fromDate).getTime(),
            toDate = new Date(this.props.toDate).getTime(),
            curDate = new Date,
            expDate = 0;

        curDate = curDate.getTime() + curDate.getTimezoneOffset()*60*1000;
        if (curDate > fromDate) {
            expDate = toDate - curDate;
        }

        this.timeTik(expDate + 1000);
    }

    timeTik(curTime) {
        curTime = curTime - 1000;
        if (curTime > 0) {
            this.setState({timeExpiration: curTime});
            this.timeOut = setTimeout(()=>{
                this.timeTik(curTime);
            }, 1000);
        } else {
            clearTimeout(this.timeOut);
            this.props.radar.showErrorLink(this.messages.timeExpired);
        }
    }

    getDate() {
        let seconds = Math.floor(this.state.timeExpiration / 1000);
        let days = Math.floor(seconds / 86400);
        seconds = seconds % 86400;
        let hours = Math.floor(seconds / 3600);
        hours = this.addZero(hours);
        seconds = seconds % 3600;
        let minutes = Math.floor(seconds / 60);
        minutes = this.addZero(minutes);
        seconds = seconds % 60;
        seconds = this.addZero(seconds);
        let out = '';

        if (days != 0) {
            out = days;
            let o = days % 10;
            if (o == 1) out += ` ${this.messages.days[0]} `;
                else if (o < 5 && o > 0) out += ` ${this.messages.days[1]} `;
                    else out += ` ${this.messages.days[2]} `;
        }

        return `${out}${hours}:${minutes}:${seconds}`;
    }

    addZero (num) {
        if (num < 10) {
            num = '0'+num;
        }
        return num;
    }

    render() {
        return (
            <div class="time-expiration-wrapper-m">
                <div class="time-expiration-logo-m"></div>
                <div class="time-expiration-message-m">{this.messages.timeExpiration}</div>
                <div class="time-expiration-m">{this.getDate()}</div>
            </div>
        );
    }
}